import { sendGAEvent } from '@next/third-parties/google';
import { GoogleAnalyticsEvent } from '../models/app.models';
import { logError, logInfo } from '../services/log.service';

export const sendGoogleAnalyticsEvent = async (event: GoogleAnalyticsEvent) => {
  try {
    sendGAEvent('event', event.name, { ...event.params });
    logInfo(['event', event.name, { ...event.params }], 'Google Analytics Event');
  } catch (error) {
    logError([error, 'event', event.name, { ...event.params }], 'Google Analytics Event');
  }
}